module.exports = __webpack_public_path__ + "static/img/94-2.a4d27a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/94-2.jpg
// module id = YXKC
// module chunks = 0